import React from 'react';

const POSITION_LABELS = ['A', 'B', 'C', 'D', 'E'];

export default function QuestionCard({ question, selectedOption, onSelect }) {
  return (
    <div style={s.card}>
      <p style={s.qText}>{question.question}</p>
      <div style={s.options}>
        {question.options.map((opt, idx) => {
          const selected = selectedOption === opt.id;
          const label = POSITION_LABELS[idx] || String(idx + 1);
          return (
            <button
              key={opt.id}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: '12px',
                padding: '14px 16px', borderRadius: '12px',
                border: selected ? '1.5px solid var(--navy)' : '1.5px solid var(--border)',
                background: selected ? 'var(--gold-light)' : '#fff',
                boxShadow: selected ? '0 0 0 3px rgba(26,58,92,0.08)' : 'none',
                cursor: 'pointer', textAlign: 'left', width: '100%', outline: 'none',
              }}
              onClick={() => onSelect(opt.id)}
            >
              <span style={{
                width: '24px', height: '24px', borderRadius: '50%', flexShrink: 0,
                background: selected ? 'var(--navy)' : 'var(--bg)',
                border: selected ? '1.5px solid var(--navy)' : '1.5px solid var(--border)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '11px', fontWeight: '700',
                color: selected ? '#fff' : 'var(--text-2)',
              }}>{label}</span>
              <span style={s.optText}>{opt.text}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

const s = {
  card: { padding: '24px 20px', flex: 1, overflowY: 'auto' },
  qText: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: '18px', fontWeight: '700', color: 'var(--navy)',
    lineHeight: '1.5', marginBottom: '24px',
  },
  options: { display: 'flex', flexDirection: 'column', gap: '10px' },
  optText: { fontSize: '14px', color: 'var(--text)', lineHeight: '1.55', paddingTop: '2px' },
};
